import styled from "styled-components";

export const Em = styled.em<{weight?:'bold' | 'default', error?:boolean, size?:string}>`
    font-weight: ${props => props.weight === 'bold' ? 800 : 500};
    font-size: ${props => props.size ? props.size : 'inherit'};
    color:${props => props.error ? props.theme.colors.text.state.error : props.theme.colors.text.highlighted};
    font-style: normal;
`;